<template>
	<section id="download" class="download-cta">
		<div class="container download-cta__inner">
			<div v-reveal class="download-cta__copy">
				<h2 class="download-cta__title">{{ t('cta.title') }}</h2>
				<p class="download-cta__body">{{ t('cta.body') }}</p>
			</div>

			<div v-reveal="100" class="download-cta__buttons">
				<a
					:href="PROFILE_FILES.en.href"
					:download="PROFILE_FILES.en.name"
					class="btn btn--gold"
				>
					<app-icon name="download" />
					<span>{{ t('cta.english') }}</span>
				</a>

				<a
					:href="PROFILE_FILES.ar.href"
					:download="PROFILE_FILES.ar.name"
					class="btn btn--outline-light"
				>
					<app-icon name="download" />
					<span>{{ t('cta.arabic') }}</span>
				</a>
			</div>
		</div>
	</section>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import AppIcon from '@/components/AppIcon.vue'
import { PROFILE_FILES } from '@/helpers/constants'

defineOptions({ name: 'DownloadCta' })

const { t } = useI18n()
</script>

<style scoped lang="scss">
.download-cta {
	position: relative;
	overflow: hidden;
	padding: clamp(52px, 7vw, 84px) 0;
	background: $color-ink;
	color: $color-paper;

	&::before {
		content: '';
		position: absolute;
		inset: 0;
		background: radial-gradient(70% 130% at 100% 0%, rgba(255, 208, 31, 0.18), transparent 60%);
	}

	@include rtl {
		&::before {
			background: radial-gradient(70% 130% at 0% 0%, rgba(255, 208, 31, 0.18), transparent 60%);
		}
	}
}

.download-cta__inner {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: clamp(26px, 4vw, 60px);
	flex-wrap: wrap;

	@include below($bp-tablet) {
		flex-direction: column;
		align-items: flex-start;
	}
}

.download-cta__copy {
	max-width: 52ch;
}

.download-cta__title {
	font-size: clamp(1.6rem, 3.4vw, 2.5rem);
	font-weight: 800;
	color: $color-paper;
}

.download-cta__body {
	margin-top: 14px;
	color: #b5b5b5;
}

.download-cta__buttons {
	display: flex;
	gap: 14px;
	flex-wrap: wrap;

	@include below($bp-mobile) {
		width: 100%;
	}
}
</style>
